import React from "react";

export const Logo = ({ compact = false, light = false }) => {
  const textMain = light ? "text-white" : "text-white";
  const textSub = light ? "text-slate-300" : "text-slate-400";
  return (
    <a href="/#inicio" className="flex items-center gap-3 group" data-testid="logo-link">
      <div className="relative w-10 h-10 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0066FF] to-[#FF6B00] rounded-xl rotate-6 group-hover:rotate-12 transition-transform duration-300" />
        <div className="relative w-9 h-9 bg-[#0A1628] rounded-lg flex items-center justify-center border border-white/10">
          <svg viewBox="0 0 24 24" className="w-5 h-5 text-[#0066FF]" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12h4l3-9 4 18 3-9h4" />
          </svg>
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-bold text-lg tracking-tight ${textMain}`} style={{ fontFamily: "Poppins, sans-serif" }}>
          FiscalBond
        </span>
        {!compact && (
          <span className={`text-[10px] uppercase tracking-[0.18em] mt-0.5 ${textSub}`}>
            Seguridad fiscal certificada
          </span>
        )}
      </div>
    </a>
  );
};

export default Logo;
